import { TrackingEvent } from '@y42/user-tracking-legacy';

export class OrgCreatedTrackingEvent extends TrackingEvent<
  {
    account_name: string;
  },
  {
    groupId?: string;
  }
> {
  readonly name = 'Account Created';
}

export class OrgDeletedTrackingEvent extends TrackingEvent<{
  account_name: string;
  role?: string;
}> {
  readonly name = 'Account Deleted';
}
